// extracted by mini-css-extract-plugin
export default {"btnContainer":"menu-lateral-btn_btnContainer__5bpuQ","icon":"menu-lateral-btn_icon__YnxW4","seta":"menu-lateral-btn_seta__wWrqZ"};